import Api from "../../axios";

export default async function apiLeaveApprovalCount() {
  return await Api.get(`/approval_leave_count`);
}
